// Based on https://developers.google.com/web/fundamentals/performance/lazy-loading-guidance/images-and-video/

import "./lazy-loading.css";

const lazySelector = "[data-lazy-image]";
const lazyClass = "lazy-image-loaded";
const lazyImages = document.querySelectorAll(`${lazySelector}`);
const rootMargin = "200px";

/* TODO: Need to clean this - but basically works with <picture> and <img> tags. was added right before launch */
const updateImageAttributes = image => {
  const element = image.tagName;
  if(element === "PICTURE") {
    const imgElement = image.querySelector("img");
    const sourceElements = image.querySelectorAll("source");
    sourceElements.forEach(source => {
      source.srcset = source.dataset.srcset;
    });
    imgElement.src = imgElement.dataset.src;
  } else {
    image.src = image.dataset.src;
  }
  image.classList.add(lazyClass);
  image.removeAttribute("data-lazy-image");
};

export default function lazyLoadImages() {
  if ("IntersectionObserver" in window) {
    const lazyImageObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const image = entry.target;
            updateImageAttributes(image);
            lazyImageObserver.unobserve(image);
            const event = new Event("lazy-image-loaded", {
              bubbles: true
            });
            image.dispatchEvent(event);
          }
        });
      },
      {
        rootMargin: rootMargin
      }
    );
    lazyImages.forEach(image => {
      lazyImageObserver.observe(image);
    });
  } else {
    lazyImages.forEach(image => {
      updateImageAttributes(image);
    });
  }
}
